import { useMemo } from "react";
import "./Timeline.css";

// Helper Functions (tidak ada perubahan)
const fmtDate = (d) =>
  d
    ? d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

const fmtMonthYear = (d) =>
  d
    ? d.toLocaleDateString("en-GB", {
        month: "long",
        year: "numeric",
      })
    : "";

const getDayDate = (d) => {
  if (!d) return null;
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  return date;
};

// Helper untuk format tanggal pendek (misal: 03-May)
const fmtShortDate = (d) => {
  return d
    ? d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
      })
    : "";
};

export default function Timeline({
  photos,
  selectedDate,
  onDateChange,
  currentMonth,
  onMonthChange,
  annotationsByDate,
}) {
  const timelineData = useMemo(() => {
    if (!photos || photos.length === 0 || !currentMonth) return null;

    // Ambil tanggal unik dari semua foto
    const allUniqueDates = [
      ...new Set(
        photos.map((p) => getDayDate(p.taken_at || p.created_at)?.getTime())
      ),
    ]
      .filter(Boolean)
      .map((ts) => new Date(ts));

    // Filter tanggal unik yang hanya ada di bulan ini
    const ticksForMonth = allUniqueDates.filter(
      (d) =>
        d.getMonth() === currentMonth.getMonth() &&
        d.getFullYear() === currentMonth.getFullYear()
    );

    if (ticksForMonth.length === 0) {
      return { ticks: [], startDate: null, endDate: null };
    }
    
    // Urutkan tanggal untuk bulan ini
    ticksForMonth.sort((a, b) => a.getTime() - b.getTime());

    // Hitung rentang untuk bulan ini saja
    const firstDayOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
    const lastDayOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
    const monthRange = lastDayOfMonth.getTime() - firstDayOfMonth.getTime();

    const ticks = ticksForMonth.map((date) => {
      const pct = monthRange > 0 ? ((date.getTime() - firstDayOfMonth.getTime()) / monthRange) * 100 : 0;
      return { date, pct };
    });

    return {
      ticks,
      startDate: ticks.length > 0 ? ticks[0].date : null,
      endDate: ticks.length > 0 ? ticks[ticks.length - 1].date : null,
    };
  }, [photos, currentMonth]);

  const selectedDay = getDayDate(selectedDate)?.getTime();
  const isShowAllActive = !selectedDate; // "Show All" aktif jika tidak ada tanggal yang dipilih

  return (
    <div className="timeline-container">
      {/* Show All sebagai tombol terpisah di kanan atas */}
      <div className="show-all-container">
        <button 
          className={`show-all-button ${isShowAllActive ? "active" : ""}`}
          onClick={() => onDateChange(null)}
        >
         
          Show All
        </button>
      </div>
      <div className="timeline-header">
        <button
          onClick={() => onMonthChange(-1)}
          aria-label="Previous month"
          className="nav-arrow"
        >
          &lt;
        </button>
        <div className="date-display">
          <div className="month-year">{fmtMonthYear(currentMonth)}</div>
          <div className="full-date">{fmtDate(selectedDate)}</div>
        </div>
        <button
          onClick={() => onMonthChange(1)}
          aria-label="Next month"
          className="nav-arrow"
        >
          &gt;
        </button>
      </div>

      <div className="timeline-track-wrapper">
        <div className="timeline-rail" />
        {timelineData?.ticks.map(({ date, pct }) => {
          const isActive = getDayDate(date)?.getTime() === selectedDay;
          const dateStr = date.toISOString().split('T')[0];
          const annots = annotationsByDate[dateStr];
          return (
            <div
              key={date.getTime()}
              className="timeline-tick-container"
              style={{ left: `${pct}%` }}
              onClick={() => onDateChange(date)}
              title={fmtDate(date)}
            >
                {/* Render titik anotasi di atas tick */}
              {annots && annots.count > 0 && (
                <div className="ann-dots-timeline">
                  {annots.colors.slice(0, 4).map((color, i) => (
                    <span key={i} className="ann-dot-timeline" style={{ backgroundColor: color }}></span>
                  ))}
                </div>
              )}
              <div className={`timeline-tick ${isActive ? "active" : ""}`} />
              {/* Label sekarang selalu ditampilkan */}
              <div className={`tick-label ${isActive ? "active" : ""}`}>
                {fmtShortDate(date)}
              </div>
            </div>
          );
        })}

     

      </div>
    </div>
  );
}
